import React, { Fragment } from 'react';
import { Form, Input, DatePicker } from 'antd';
import {
  start_date,
  dateFormat,
} from '../../../../../../common/utils/configFormField';
import QuestionPopup from '../../../../../../common/components/questionPopup/questionPopup';
import { diagnosticCardPopupContent } from '../contentsForPopover';
import locale from 'antd/lib/date-picker/locale/ru_RU';

const DiagnosticCard = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <Fragment>
      <span className="label">Диагностическая карта:</span>
      <Form.Item>
        {getFieldDecorator('diagnosticCardNum', {
          validateTrigger: 'onBlur',
          rules: [{
            validator: (rule, value, callback) => {
              if (value && value.length < 21) {
                callback('Номер должен быть не менее 21 символа')
              } else {
                callback();
              }
            }
          }]
        })(
          <Input
            maxLength={21}
            className="longInput"
            placeholder="Укажите серию и номер диагностической карты"
            disabled={disabled}
          />
        )}
      </Form.Item>
      {disabled ? (
        <div></div>
      ) : (
          <QuestionPopup
            width="24px"
            height="24px"
            trigger="click"
            fill="#00a8ff"
          >
            {diagnosticCardPopupContent}
          </QuestionPopup>
        )}

      <div className="diagnosticCardArea">
        <span className="label">Действительна до:</span>
        <Form.Item>
          {getFieldDecorator('diagnosticCardValidUntilDate')(
            <DatePicker
              placeholder="ДД.ММ.ГГГГ"
              format={dateFormat}
              disabledDate={start_date}
              className="basicInput"
              disabled={disabled}
              locale={locale}
            />
          )}
        </Form.Item>
      </div>
      <div></div>
    </Fragment>
  );
};

export default DiagnosticCard;
